import { ReactComponent as SavvySvg } from "../../../../src/mdx/blog/customer-success-story-microsoft-365-embedded-savvy/savvy.svg";
import * as React from 'react';
export default {
  SavvySvg,
  React
};